import script from "./SkillsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillsModal.vue?vue&type=script&setup=true&lang=ts"

import "./SkillsModal.vue?vue&type=style&index=0&id=12d46424&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d46424"]])

export default __exports__